import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-configurator-select-field',
  templateUrl: './select-field.component.html'
})
export class SelectFieldComponent {
  @Input() label: String = '';
  @Input() labelID: String = '';
  @Input() defaultValue: Number = 400;
  @Input() options: any = {};
  @Input() itemList: any = {};

  constructor() {}
}
